import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const features = [
  "Devis 100% gratuit sous 24h",
  "Fabrication dans nos ateliers en Île-de-France",
  "Installation par nos équipes qualifiées",
  "Garantie décennale sur tous nos travaux",
  "Accompagnement administratif complet",
];

export function FeaturesStrip() {
  return (
    <section className="py-12 sm:py-16 border-y border-[#1a1a1a] bg-[#0a0a0a]" data-testid="features-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-4">
          {features.map((text, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08 }}
              className="flex items-start gap-3"
              data-testid={`feature-${idx}`}
            >
              <div className="shrink-0 w-10 h-10 rounded-full border-2 border-[#00FF66] flex items-center justify-center">
                <ArrowRight className="w-4 h-4 text-[#00FF66]" />
              </div>
              <p className="text-sm font-semibold text-white uppercase tracking-wide leading-tight font-['Outfit',sans-serif]">
                {text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
